import React, { Component } from 'react'
import styled from 'styled-components/macro'
import { Text, Graphic, Button, Spacing } from '../../../components/ui'

const width = window.innerWidth

const HeaderWrapper = styled.div`
  position: absolute;
  top: -80px;
`
const SkipWrapper = styled.div`
  position: absolute;
  top: 50px;
  right: 80px;
  width: 130px;
`

const HeadingWrapper = styled.div`
  position: absolute;
  top: 80px;
`
const GraphicWrapper = styled.div`
  position: absolute;
  top: 180px;
`
const TextHeaderWrapper = styled.div`
  position: absolute;
  width: 400px;
  top: 460px;
`
const TextWrapper = styled.div`
  position: absolute;
  width: 550px;
  top: 550px;
`
const ButtonWrapper = styled.div`
  position: absolute;
  width: 440px;
  top: 690px;
`

export class Onboarding5 extends Component {
  state = {
    login: true, // switch between Login and SignUp
    email: '',
    password: '',
    name: '',
  }

  render() {
    const { history } = this.props
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <HeaderWrapper>
          <Graphic name="Header" width={width} />
        </HeaderWrapper>
        <SkipWrapper>
          <Button
            block
            style={{
              borderWidth: 0,
              backgroundColor: 'rgba(225, 225, 225, 0.2)',
              fontWeight: 'bold',
            }}
          >
            Skip
          </Button>
        </SkipWrapper>
        <HeadingWrapper>
          <Text
            color="white"
            bold
            style={{ fontSize: 50, fontFamily: 'Poppins' }}
          >
            How it Works
          </Text>
        </HeadingWrapper>
        <GraphicWrapper>
          <Graphic name="OnboardingNotifications" width={width * 0.32} />
        </GraphicWrapper>
        <TextHeaderWrapper>
          <Text center bold style={{ fontFamily: 'poppins', fontSize: 24 }}>
            Get notified when traits match you with a paid opportunity
          </Text>
        </TextHeaderWrapper>
        <TextWrapper>
          <Text center style={{ fontFamily: 'rubik' }}>
            We don’t believe in wasting time! Accept studies, ads, and offers
            that pay you in cash and UBDI points as our community grows
          </Text>
        </TextWrapper>
        <ButtonWrapper>
          <Spacing direction="row">
            <Button
              outline
              block
              style={{ width: '220px' }}
              onClick={() => history.push('./four')}
            >
              Previous
            </Button>
            <Button
              outline
              block
              style={{ width: '220px' }}
              onClick={() => history.push('./six')}
            >
              Next
            </Button>
          </Spacing>
        </ButtonWrapper>
      </div>
    )
  }
}
